<div class="ion-text-center">
    <ion-img class="modal-logo" src="assets/icons/logo_orange_full.png"></ion-img>
</div>
<ion-grid class="modal-content">
    <ion-row class="ion-justify-content-center">
        <ion-col size="10">
            <h3 class="ion-text-center">
                <strong> Website Update Detected. </strong>
            </h3>
            <p>A new version of the website is available click 'OK' to continue.</p>
        </ion-col>
    </ion-row>
</ion-grid>
<ion-footer>
    <ion-toolbar>
        <ion-button type="button" expand="block" [disabled]="clickedOkButton" (click)="dismiss()">OK</ion-button>
    </ion-toolbar>
</ion-footer>
